'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuestionIcon = function () {
  function QuestionIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M7.575 7.5a2.5 2.5 0 0 1 4.858.833c0 1.667-2.5 2.5-2.5 2.5',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }),
      _react2['default'].createElement('path', {
        clipRule: 'evenodd',
        d: 'M10 18.333a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.666z',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }),
      _react2['default'].createElement(
        'mask',
        {
          id: 'a',
          fill: '#fff'
        },
        _react2['default'].createElement('ellipse', {
          cx: '10',
          cy: '14.167',
          rx: '.833',
          ry: '.833'
        })
      ),
      _react2['default'].createElement('ellipse', {
        cx: '10',
        cy: '14.167',
        rx: '.833',
        ry: '.833',
        fill: '#A8A4B9'
      }),
      _react2['default'].createElement('path', {
        d: 'M9.833 14.167c0-.092.075-.167.167-.167v2c1.012 0 1.833-.82 1.833-1.833h-2zM10 14c.092 0 .167.075.167.167h-2C8.167 15.179 8.987 16 10 16v-2zm.167.167a.167.167 0 0 1-.167.166v-2c-1.012 0-1.833.821-1.833 1.834h2zm-.167.166a.167.167 0 0 1-.167-.166h2c0-1.013-.82-1.834-1.833-1.834v2z',
        fill: '#A8A4B9',
        mask: 'url(#a)'
      })
    );
  }

  return QuestionIcon;
}();

QuestionIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};
var OnlinepbxQuestion = (_temp = _class = function (_React$Component) {
  _inherits(OnlinepbxQuestion, _React$Component);

  function OnlinepbxQuestion(props) {
    _classCallCheck(this, OnlinepbxQuestion);

    var _this = _possibleConstructorReturn(this, (OnlinepbxQuestion.__proto__ || Object.getPrototypeOf(OnlinepbxQuestion)).call(this, props));

    _this.state = {
      isModal: false,
      coordinateX: '',
      coordinateY: '',
      isPushTab: false,
      isRight: false
    };
    if (process.env.IS_BROWSER + '' !== 'false') {
      _this.domNode = document.createElement('div');
    }
    _this.isCursor = true;
    _this.pushTab = _this.pushTab.bind(_this);
    _this.renderModal = _this.renderModal.bind(_this);
    _this.handleUpdate = _this.handleUpdate.bind(_this);
    _this.toggleModal = _this.toggleModal.bind(_this);
    return _this;
  }

  _createClass(OnlinepbxQuestion, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        document.addEventListener('keydown', this.pushTab);
        window.addEventListener('resize', this.handleUpdate);
        var container = this.questionEl && this.questionEl.getBoundingClientRect();
        var windowSize = window.innerWidth;
        var scrollBlock = document.querySelectorAll('.scrollbar__dark');
        scrollBlock && scrollBlock.forEach(function (handler) {
          return handler.addEventListener('scroll', _this2.handleUpdate);
        });
        this.setState({
          coordinateX: container.x,
          coordinateY: container.y + container.height
        });
        var betweenRightAndPopup = windowSize - container.x;
        if (betweenRightAndPopup < (this.props.right || 215)) {
          this.setState({ isRight: true });
        }
        document.body.appendChild(this.domNode);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        var _this3 = this;

        var scrollBlock = document.querySelectorAll('.scrollbar__dark');
        scrollBlock && scrollBlock.forEach(function (handler) {
          return handler.removeEventListener('scroll', _this3.handleUpdate);
        });
        window.removeEventListener('resize', this.handleUpdate);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'pushTab',
    value: function () {
      function pushTab(evt) {
        if (evt.keyCode === 9) {
          this.setState({ isPushTab: true });
        }
      }

      return pushTab;
    }()
  }, {
    key: 'toggleModal',
    value: function () {
      function toggleModal(text, isOpenModal) {
        this.handleUpdate();
        text && this.setState({ isModal: isOpenModal || !this.state.isModal });
      }

      return toggleModal;
    }()
  }, {
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps, nextState) {
        return (this.state.coordinateY || '') !== (nextState.coordinateY || '') || (this.state.coordinateX || '') !== (nextState.coordinateX || '') || this.state.isModal !== nextState.isModal || this.state.isRight !== nextState.isRight;
      }

      return shouldComponentUpdate;
    }()
  }, {
    key: 'handleUpdate',
    value: function () {
      function handleUpdate() {
        var container = this.questionEl && this.questionEl.getBoundingClientRect();
        this.setState({
          coordinateX: container.x,
          coordinateY: container.y + container.height
        });
      }

      return handleUpdate;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this4 = this;

        var _props = this.props,
            text = _props.text,
            openModalByHover = _props.openModalByHover,
            _onMouseEnter = _props.onMouseEnter,
            _onMouseLeave = _props.onMouseLeave,
            _props$title = _props.title,
            title = _props$title === undefined ? 'Описание' : _props$title;

        var icon = this.props.icon || _react2['default'].createElement(QuestionIcon, {
          className: (0, _classnames2['default'])('onlinepbx__lib__question__icon', {
            onlinepbx__lib__question__icon__active: this.state.isModal
          })
        });
        return [_react2['default'].createElement(
          'div',
          {
            key: 'question_wrapper',
            tabIndex: '0',
            onMouseEnter: function () {
              function onMouseEnter() {
                typeof _onMouseEnter === 'function' && _onMouseEnter();

                _this4.isCursor = false;
              }

              return onMouseEnter;
            }(),
            onMouseLeave: function () {
              function onMouseLeave() {
                typeof _onMouseLeave === 'function' && _onMouseLeave();

                _this4.isCursor = true;
              }

              return onMouseLeave;
            }(),
            onBlur: function () {
              function onBlur() {
                return _this4.isCursor && _this4.setState({ isModal: false });
              }

              return onBlur;
            }(),
            className: 'onlinepbx__lib__question'
          },
          _react2['default'].createElement(
            'button',
            {
              tabIndex: '0',
              onFocus: function () {
                function onFocus() {
                  return _this4.state.isPushTab && _this4.setState({ isModal: true });
                }

                return onFocus;
              }(),
              title: !this.state.isModal && title || '',
              ref: function () {
                function ref(node) {
                  if (node && !_this4.questionEl) {
                    _this4.forceUpdate();
                  }
                  _this4.questionEl = node || _this4.questionEl;
                }

                return ref;
              }(),
              onBlur: function () {
                function onBlur() {
                  return _this4.setState({ isPushTab: false });
                }

                return onBlur;
              }(),
              onClick: function () {
                function onClick(evt) {
                  evt.stopPropagation();
                  evt.preventDefault();
                  if (!openModalByHover) {
                    _this4.toggleModal(text);
                  }
                }

                return onClick;
              }(),
              onMouseEnter: function () {
                function onMouseEnter() {
                  if (!openModalByHover) {
                    return;
                  }
                  _this4.toggleModal(text, true);
                }

                return onMouseEnter;
              }(),
              onMouseLeave: function () {
                function onMouseLeave() {
                  if (!openModalByHover) {
                    return;
                  }
                  _this4.toggleModal(text, false);
                }

                return onMouseLeave;
              }(),
              className: 'onlinepbx__lib__question__button'
            },
            icon
          )
        ), this.state.isModal && _reactDom2['default'].createPortal(this.renderModal(text), this.domNode)];
      }

      return render;
    }()
  }, {
    key: 'renderModal',
    value: function () {
      function renderModal(text) {
        var _this5 = this;

        var _props2 = this.props,
            className = _props2.className,
            children = _props2.children;

        return _react2['default'].createElement(
          'div',
          {
            style: _extends({}, this.state.isRight ? { right: 15 } : { left: this.state.coordinateX }, {
              top: !(this.state.coordinateY >= window.screen.height / 2) && this.state.coordinateY || 'auto',
              bottom: this.state.coordinateY >= window.screen.height / 2 && window.innerHeight - this.state.coordinateY + 25,
              maxWidth: String(this.props.maxWidth) + 'px'
            }),
            onMouseEnter: function () {
              function onMouseEnter() {
                _this5.isCursor = false;
              }

              return onMouseEnter;
            }(),
            onMouseLeave: function () {
              function onMouseLeave() {
                _this5.isCursor = true;
              }

              return onMouseLeave;
            }(),
            onClick: function () {
              function onClick(evt) {
                return evt.stopPropagation();
              }

              return onClick;
            }(),
            onBlur: function () {
              function onBlur() {
                return _this5.isCursor && _this5.setState({ isModal: false });
              }

              return onBlur;
            }(),
            tabIndex: '0',
            className: (0, _classnames2['default'])('onlinepbx__lib__question__modal', className)
          },
          _react2['default'].createElement(
            'div',
            { className: 'onlinepbx__lib__question__text' },
            text,
            children
          )
        );
      }

      return renderModal;
    }()
  }]);

  return OnlinepbxQuestion;
}(_react2['default'].Component), _class.defaultProps = {
  maxWidth: 215
}, _temp);
exports['default'] = OnlinepbxQuestion;